module.exports = __webpack_public_path__ + "static/media/individ.aa6c035f.jpg";